export interface LeadActionTypes {
  type: LeadActions;
  payload?: any;
}

export enum LeadActions {
  CREATE_LEAD = "CREATE_LEAD",

  GET_LEAD_LIST = "GET_LEAD_LIST",
  GET_MY_LEAD_LIST = "GET_MY_LEAD_LIST",

  SET_LEAD_LIST = "SET_LEAD_LIST",
  SET_MY_LEAD_LIST = "SET_MY_LEAD_LIST",

  SET_LEAD_LIST_PAGE_COUNT = "SET_LEAD_LIST_PAGE_COUNT",
  SET_MY_LEAD_LIST_PAGE_COUNT = "SET_MY_LEAD_LIST_PAGE_COUNT",

  GET_LEAD_DATA_BY_ID = "GET_LEAD_DATA_BY_ID",
  GET_MY_LEAD_DATA_BY_ID = "GET_MY_LEAD_DATA_BY_ID",

  SET_LEAD_DATA_BY_ID = "SET_LEAD_DATA_BY_ID",
  SET_MY_LEAD_DATA_BY_ID = "SET_MY_LEAD_DATA_BY_ID",

  EDIT_LEAD_DATA_BY_ID = "EDIT_LEAD_DATA_BY_ID",
  DELETE_LEAD = "DELETE_LEAD",
}
